/** Same-origin BFF base path — no per-environment URL file. */
export const AMP_API_BASE_URL = '/api';
